import React from 'react';
import SearchService from '../classes/SearchService';
import getExternalLink from '../functions/getExternalLink';

import { 
    DEFAULT_BIKE_COLOR,
    START_IMG_INDEX,
    DEFAULT_IMAGE_SIZE, 
    BIKE_IMG_SOURCE, 
    IMG_EXTENSION,
    ROTATE_360_FRAMES
 } from '../constants/bike';

import { DEVICE } from '../constants/device';

// Used for rendering bike 360 rotation
export default class Bike360 {

    constructor(bike, color = DEFAULT_BIKE_COLOR) {
        this.folder = bike.folder;
        this.colors = bike.colors;
        this.wheel = bike.wheel;
        this.color = color;
        this.selectedColor = this.colors.filter(color => color === this.color)[0];
        this.type = bike.type;
    }

    // Path depends on params f.e. images/h42/16/premium/white/14.jpg
    getImagePath = (source, index) => `${BIKE_IMG_SOURCE}/${source.folder}/${source.wheel}/${source.type}/${this.selectedColor ? this.selectedColor : this.colors[0]}/${index}${IMG_EXTENSION}`;

    // Returns array of images for bike rendering
    // f.e. for 36-slides render, main image starts with 5 slide [5..36, 1..5]
    // Mobile version consist every 3-d image (speed improvements)
    getImages(key = DEVICE.DESKTOP) {

        const arrBeforeStart = [];
        const arrAfterStart = [];

        const createImgArray = index => {

            const imgSRC = this.getImagePath(this, index);
            const image = <img key={index} src={imgSRC} width={DEFAULT_IMAGE_SIZE.WIDTH} height={DEFAULT_IMAGE_SIZE.HEIGHT} alt="bike" />;

            index < START_IMG_INDEX
                ? arrBeforeStart.push(image)
                : arrAfterStart.push(image)  

        }

        for (let i = 1; i <= ROTATE_360_FRAMES; i++) {
            if (key === DEVICE.MOBILE) {
                if (i % 3 === 0 || i === START_IMG_INDEX) { createImgArray(i) }
            } else { createImgArray(i) }    
        }

        return arrAfterStart.concat(arrBeforeStart);

    }

    // Faster method for getting only one image for mobile
    getMobileImage() {
        return (index = START_IMG_INDEX) => this.getImagePath(this, index);
    }

    // On component mounting or switching between units
    getAllStartImgs() {

        const searchService = new SearchService();
        const firstBikes = searchService.getFirstImages();      

        return firstBikes.map((bike, index) => {
            const imgSRC = this.getImagePath(bike, index);
            return <img key={index} src={imgSRC} alt="bike" width={DEFAULT_IMAGE_SIZE.WIDTH} height={DEFAULT_IMAGE_SIZE.HEIGHT} />

        })

    }

    // Global img links used in HTML-email etc.
    getGlobalSRC() {
        const externalLink = getExternalLink();
        return `${externalLink}/${this.getImagePath(this, START_IMG_INDEX)}`;
    }

}


// WEBPACK FOOTER //
// ./src/classes/Bike360.js